export default {
	home: {
		afunOriginals: "AFun Originales",
		slots: "Tragamonedas",
		liveCasino: "Casino en Vivo",
		casualGames: "Juegos Casuales",
		newReleases: "Nuevos Lanzamientos",
		casinoTitle: "Casino",
		casinoDesc: "Disfruta juegos de casino con miles de tragamonedas, dealers en vivo y juegos de mesa",
		goToCasino: "Ir al Casino",
		sportsTitle: "Deportes",
		sportsDesc: "Apuesta en Fútbol, Básquetbol, Tenis y más deportes con las mejores momios",
		goToSports: "Ir a Deportes",
		liveTitle: "En Vivo",
		liveDesc: "Acción en tiempo real con dealers en vivo y experiencia de juego interactiva",
		goToLive: "Ir a En Vivo",
		latestBetRace: "Últimas Apuestas y Carreras",
		sports: "Deportes",
		latestBets: "Últimas Apuestas",
		game: "Juego",
		player: "Jugador",
		bet: "Apuesta",
		multiplier: "Multiplicador",
		profit: "Ganancia",
		top10Games: "Top 10 Juegos",
		vip: "VIP",
		rewards: "Recompensas",
		affiliate: "Afiliado",
		promotion: "Promoción"
	},

	latestBetRace: {
		title: "Gran Premio de la Clasificación de Juegos",
		playerBetRank: "Apuestas de Jugadores de Hoy",
		playerWinRank: "Victorias de Jugadores de Hoy",
		gameBetRank: "Apuestas de Juegos de Hoy",
		gameWinRank: "Retornos de Juegos de Hoy",
		player: "Jugador",
		game: "Juego",
		bet: "Apuesta",
		profit: "Ganancia",
		ratio: "Ratio de Pago",
		totalBet: "Apuesta Total",
		totalReturn: "Retorno Total",
		maxBet: "Apuesta Máxima",
		gameRatio: "% de Retorno",
		noData: "No Hay Datos Disponibles",
	},

	GameClassify: {
		casinoTitle: "Casino",
		casinoDesc: "Disfruta de juegos de casino de los mejores proveedores",
		casinoBtn: "Ir al Casino",
		sportsTitle: "Deportes",
		sportsDesc: "Apuesta en Fútbol, Cricket, NFL, eSports y más de 80 deportes",
		sportsBtn: "Ir a Deportes",
		liveTitle: "En Vivo",
		liveDesc: "Acción en tiempo real con crupieres en vivo",
		liveBtn: "Ir al En Vivo"
	}
}